var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.947,
    height: 102.433,
    viewBox: "0 0 81.947 102.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fmd_bad_24dp_5F6368_FILL0_wght400_GRAD0_opsz24",
    d: "M195.852-833.9H206.1v-25.608H195.852Zm5.122,20.487a4.956,4.956,0,0,0,3.649-1.472,4.956,4.956,0,0,0,1.473-3.649,4.956,4.956,0,0,0-1.473-3.649,4.956,4.956,0,0,0-3.649-1.472,4.956,4.956,0,0,0-3.649,1.472,4.956,4.956,0,0,0-1.472,3.649,4.956,4.956,0,0,0,1.472,3.649A4.956,4.956,0,0,0,200.973-813.418Zm0,22.279q15.621-14.341,23.176-26.057T231.7-838q0-13.957-8.9-22.855a29.683,29.683,0,0,0-21.831-8.9,29.683,29.683,0,0,0-21.831,8.9q-8.9,8.9-8.9,22.855,0,9.091,7.554,20.807T200.973-791.139Zm0,13.572q-20.615-17.542-30.794-32.587T160-838q0-19.206,12.356-30.6A40.93,40.93,0,0,1,200.973-880a40.93,40.93,0,0,1,28.617,11.4q12.356,11.4,12.356,30.6,0,12.8-10.179,27.849T200.973-777.567ZM200.973-839.027Z",
    transform: "translate(-160 880)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertPoint);
export default __webpack_public_path__ + "static/media/alert-point.d536442c1cea96f706a91904e7b22f51.svg";
export { ForwardRef as ReactComponent };